// extracted by mini-css-extract-plugin
module.exports = {"title":"ShortRadio_title__FwxB_"};